import styled, { css } from 'styled-components';
import { theme } from '../../../styles/theme';
import BadgeRound from '../../BadgeRound';

export const Container = styled.div`
  flex: 1;
  min-width: 100%;
  display: flex;
  margin: 0 -4px 12px -4px;
`;

export const SingleDay = styled(BadgeRound)<{ $isActive?: boolean }>`
  margin: 0 4px;
  font-weight: 600;
  transition: background-color 0.2s ease-in-out;
  background-color: ${theme.colors.blue500};
  color: ${theme.colors.secondary900};
  &:hover {
    cursor: pointer;
    // By design background-color is static for both hover and active states
    background-color: #60a6ff;
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: #60a6ff;
    `}
`;
